import { radius } from '../../utils/radius.js'
import { colors } from '../../tokens/colors.js'

type SliderProps = {
  max: number
  value: number
  step?: number
  onChange: (value: number) => void
  style?: React.CSSProperties
}

export const Slider = ({
  max,
  value,
  step = 1,
  onChange,
  style,
}: SliderProps) => {
  const x = (value / max) * 100
  return (
    <div
      style={{
        height: 8,
        position: 'relative',
        borderRadius: radius[8],
        ...style,
      }}
    >
      <input
        type="range"
        min={0}
        max={max}
        step={step}
        value={value}
        style={{
          position: 'absolute',
          opacity: 0,
          width: '100%',
          height: '100%',
        }}
        onChange={(e) => onChange(Number(e.target.value))}
      />
      <div
        style={{
          position: 'absolute',
          pointerEvents: 'none',
          padding: 2,
          height: '12px',
          width: '12px',
          boxShadow: `0px 0px 2px ${colors.black60}, inset 0px 0px 2px ${colors.black60}`,
          borderRadius: '50%',
          top: 0,
          left: `${x}%`,
          bottom: 0,
          transform: `translate3d(-${x}%,-2px,0)`,
          border: `2px solid ${colors.white100}`,
        }}
      />
    </div>
  )
}
